import script from "./StudentDetailsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentDetailsModal.vue?vue&type=script&setup=true&lang=js"

import "./StudentDetailsModal.vue?vue&type=style&index=0&id=6e56d1d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e56d1d4"]])

export default __exports__